import { render, staticRenderFns } from "./imageViewerComponent.vue?vue&type=template&id=1f18cf49&scoped=true&"
import script from "./imageViewerComponent.vue?vue&type=script&lang=js&"
export * from "./imageViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./imageViewerComponent.vue?vue&type=style&index=0&id=1f18cf49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f18cf49",
  null
  
)

export default component.exports